import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=3cb0ae46&scoped=true&lang=html&"
import script from "./Label.vue?vue&type=script&lang=js&"
export * from "./Label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb0ae46",
  null
  
)

export default component.exports